export const FETCH_SYSTEM_SETTINGS = "FETCH_SYSTEM_SETTINGS"
export const UPDATE_SYSTEM_SETTINGS = "UPDATE_SYSTEM_SETTINGS"
export const SET_SYSTEM_CLIENTNAME = "SET_SYSTEM_CLIENTNAME"
export const CLEAR_SYSTEM_CLIENTNAME = "CLEAR_SYSTEM_CLIENTNAME"